import React, { useState } from 'react';
import { contentApi } from '../../services/api';
import { useContentPlanCache } from '../../hooks/useContentPlanCache';

interface AddNewDayButtonProps {
  contentPlanId: string;
  onDayAdded: () => void;
  disabled?: boolean;
  lastDayDate?: string; // Дата последнего дня в контент-плане
}

export const AddNewDayButton: React.FC<AddNewDayButtonProps> = ({
  contentPlanId,
  onDayAdded,
  disabled = false,
  lastDayDate
}) => {
  const [isAdding, setIsAdding] = useState(false);
  const { invalidateContentPlanData } = useContentPlanCache();

  const handleAddNewDay = async () => { 
    if (!contentPlanId || isAdding) return;

    setIsAdding(true);
    
    try {
      let dateString: string;
      
      if (lastDayDate) {
        // Если есть последний день, добавляем +1 день к нему
        const lastDate = new Date(lastDayDate);
        lastDate.setDate(lastDate.getDate() + 1);
        dateString = lastDate.toISOString().split('T')[0]; // YYYY-MM-DD format
      } else {
        // Если нет последнего дня, используем завтрашнюю дату как fallback
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        dateString = tomorrow.toISOString().split('T')[0]; // YYYY-MM-DD format
      }

      const response = await contentApi.addNewDay({
        contentPlanId,
        date: dateString
      });

      if (response.data?.success) {
        console.log('✅ Новый день добавлен:', dateString);
        
        // Инвалидируем кэш для обновления данных
        console.log('🔄 [ADD-DAY] Инвалидируем кэш после добавления дня');
        invalidateContentPlanData(contentPlanId);
        
        // Вызываем callback для дополнительных действий
        onDayAdded();
      } else {
        throw new Error(response.data?.message || 'Ошибка при добавлении дня');
      }
    } catch (error) {
      console.error('Ошибка при добавлении нового дня:', error);
      // Здесь можно добавить уведомление об ошибке
    } finally {
      setIsAdding(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-[340px]">
      <button
        onClick={handleAddNewDay}
        disabled={disabled || isAdding}
        className="w-16 h-16 bg-blue-100 hover:bg-blue-200 dark:bg-blue-900/50 dark:hover:bg-blue-900 text-blue-700 dark:text-blue-300 rounded-lg transition-colors duration-200 flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
        title="Добавить новый день"
      >
        {isAdding ? (
          <svg className="animate-spin h-8 w-8" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <line x1="5" y1="12" x2="19" y2="12"></line>
          </svg>
        )}
      </button>
    </div>
  );
};
